module.exports = __webpack_public_path__ + "media/images/teaching-405bfa3a24030641636d5be8c8c91003.jpg";